import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_3 = { class: "w90 pad15 mb40" }
const _hoisted_4 = { class: "fl" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", {
  class: "fl fw600",
  style: {"width":"150px","margin-left":"5%"}
}, "一覧", -1)
const _hoisted_6 = {
  key: 0,
  class: "fl arial"
}
const _hoisted_7 = {
  class: "fs28 fw600",
  style: {"margin-left":"12px"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "fs11" }, "社招待済み", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = { class: "w100" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "fl fw600 fs20 mr20" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["src", "onClick"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_20 = {
  key: 0,
  class: "membersContent pad10 rad10"
}
const _hoisted_21 = {
  key: 0,
  class: ""
}
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "centered mt20" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "grey" }, "メンバーが見つかりませんでした。", -1)
const _hoisted_25 = ["src"]
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { class: "fl mr20" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = { class: "fs12" }
const _hoisted_30 = { class: "fr" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["src", "onClick"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_35 = { class: "w100 mt20 pad20 hoverLgreyBg rad10" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "ml30 fs12 fw600" }, "このグループに招待", -1)
const _hoisted_37 = { class: "ml30" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InviteMembersContent = _resolveComponent("InviteMembersContent")!
  const _component_RoomsLoader = _resolveComponent("RoomsLoader")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_InviteMembersContent, {
      ref: "InviteContent",
      users: _ctx.users,
      type: `client_ug`,
      onInviteNewClient: _ctx.inviteNewClient,
      newClientInfoDic: _ctx.newUserGroupInfo
    }, null, 8, ["users", "onInviteNewClient", "newClientInfoDic"]),
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        (_ctx.ugs)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.ugs.length), 1),
              _hoisted_8,
              _hoisted_9
            ]))
          : _createCommentVNode("", true),
        _hoisted_10
      ]),
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ugs, (ug, ugindex) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "w80",
            style: {"margin-left":"200px"},
            key: `${ugindex}${ug.user_group_id}${_ctx.selectedUgId}`
          }, [
            _createElementVNode("div", {
              class: "padw15 w100 rad10 hoverLgreyBg pointer",
              onClick: ($event: any) => (_ctx.showClientMembers(ug))
            }, [
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/icons/organizations.png`),
                width: "21",
                height: "22",
                class: "fl mr10 mt2"
              }, null, 8, _hoisted_14),
              _createElementVNode("div", _hoisted_15, _toDisplayString(ug.company_name), 1),
              _createElementVNode("div", {
                class: "fl fs12 fw600 skyblue pointer mt8 mr10",
                onClick: ($event: any) => (_ctx.showClientMembers(ug))
              }, " メンバーを表示・招待 ", 8, _hoisted_16),
              _withDirectives(_createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
                width: "20",
                height: "20",
                class: "pointer fr mr20",
                style: {},
                onClick: ($event: any) => (_ctx.showUnlinkGroupModal(ug))
              }, null, 8, _hoisted_17), [
                [
                  _directive_tooltip,
                  `招待を解除`,
                  void 0,
                  { top: true }
                ]
              ]),
              _hoisted_18
            ], 8, _hoisted_13),
            _hoisted_19,
            (_ctx.selectedUgId == ug.user_group_id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  (!_ctx.membersDic[ug.user_group_id])
                    ? (_openBlock(), _createElementBlock("section", _hoisted_21, [
                        _createVNode(_component_RoomsLoader)
                      ]))
                    : (_ctx.membersDic[ug.user_group_id].length == 0)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _hoisted_24,
                            _createElementVNode("img", {
                              src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                              width: "40",
                              height: "40"
                            }, null, 8, _hoisted_25)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("section", _hoisted_26, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.membersDic[ug.user_group_id], (user) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "w100 pad10 hoverLgreyBg rad10",
                              key: `${user.user_id}${_ctx.membersDic[ug.user_group_id]}`
                            }, [
                              _createVNode(_component_UserIcon, {
                                member: user,
                                width: 38,
                                canEdit: false,
                                updateSelf: false,
                                showTooltip: false,
                                class: "fl mr10 ml40"
                              }, null, 8, ["member"]),
                              _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("span", null, _toDisplayString(user.name), 1),
                                _hoisted_28,
                                _createElementVNode("span", _hoisted_29, _toDisplayString(user.email), 1)
                              ]),
                              _createElementVNode("div", _hoisted_30, [
                                (user.tutorial_phase < 20)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      style: {"text-decoration":"underline"},
                                      class: "lgrey pointer fw400 mr10",
                                      onClick: ($event: any) => (_ctx.resendInviteMail(user))
                                    }, "招待を再送信", 8, _hoisted_31))
                                  : _createCommentVNode("", true),
                                (user.tutorial_phase < 20 && false)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      style: {"text-decoration":"underline"},
                                      class: "lgrey pointer fw400 mr10",
                                      onClick: ($event: any) => (_ctx.copyInviteUrl(user))
                                    }, "招待URLをコピー", 8, _hoisted_32))
                                  : _createCommentVNode("", true),
                                false
                                  ? _withDirectives((_openBlock(), _createElementBlock("img", {
                                      key: 2,
                                      src: _ctx.$getAssetImageUrl(`/assets/icons/trash.png`),
                                      width: "16",
                                      height: "19",
                                      class: "pointer fr",
                                      style: {"margin-right":"40px"},
                                      onClick: ($event: any) => (_ctx.alertDeleteUser(user))
                                    }, null, 8, _hoisted_33)), [
                                      [
                                        _directive_tooltip,
                                        `アカウントを削除`,
                                        void 0,
                                        { top: true }
                                      ]
                                    ])
                                  : _createCommentVNode("", true)
                              ]),
                              _hoisted_34
                            ]))
                          }), 128))
                        ])),
                  _createElementVNode("div", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("div", _hoisted_37, [
                      _createVNode(_component_MdTextfieldTag, {
                        name: "担当者名（様不要）",
                        style: {"height":"56px","min-width":"280px","width":"280px"},
                        class: "fl fs14 mr10",
                        value: _ctx.newClientInfo.name,
                        onInputValue: _ctx.inputClientName
                      }, null, 8, ["value", "onInputValue"]),
                      _createVNode(_component_MdTextfieldTag, {
                        name: "メールアドレス",
                        style: {"height":"56px","min-width":"280px","width":"280px"},
                        class: "fl fs14 mr10",
                        value: _ctx.newClientInfo.email,
                        onInputValue: _ctx.inputClientEmail,
                        onBlur: _cache[0] || (_cache[0] = ($event: any) => (_ctx.checkEmailField(_ctx.newClientInfo.email))),
                        errMessage: _ctx.failedMail ? `不正なメールアドレスです` : null
                      }, null, 8, ["value", "onInputValue", "errMessage"]),
                      _createElementVNode("button", {
                        type: "submit",
                        class: "fl pointer centered circle_button fs14 rad8 noborder skyblueBg mt10",
                        style: {"height":"50px"},
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.inviteNewClient(_ctx.newClientInfo)))
                      }, " 招待 ")
                    ]),
                    _hoisted_38
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])
  ]))
}